import LocationsOnboardingDialog from './LocationsOnboardingDialog';

export default LocationsOnboardingDialog;
